import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const RamadanBarchart = ({ data, level }) => {
  return (
    <div className=" bg-gradient-to-tl from-yellow-200 to-orange-100 rounded">
      <ResponsiveContainer className="mx-auto" height={200} width={200}>
        <BarChart data={[data[0]]}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis type="number" domain={[0, 100]} />
          <YAxis />
          <Tooltip />
          <Bar dataKey="Score" fill="#fc2403" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RamadanBarchart;
